import React, { Component } from "react";
import { Col, Row, Media, Button } from "reactstrap";
import { getFileLinkWithPage } from "../../helpers/utils";

import dropdownDown from "../../images/dropdownDown.png";

import appClasses from "../../App.module.scss";

import ResultText from "./ResultText";
import MoreResults from "./MoreResults";

class PageResults extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.openPdf = this.openPdf.bind(this);
    this.state = {
      collapse: false
    };
  }

  toggle() {
    this.setState({ collapse: !this.state.collapse });
  }

  openPdf(url) {
    const newWin = window.open();
    const html = "<PdfViewer pdfUrl={url} />";
    newWin.document.write(html);
  }

  render() {
    const result = this.props.result;
    const dataArr =
      result.highlight["data.melingo"] != undefined
        ? result.highlight["data.melingo"]
        : result.highlight["data.raw"];
    return (
      <div>
        <a
          className={appClasses.resultContantLink}
          target="_blank"
          href={getFileLinkWithPage(
            result.hit.docIdentity,
            result.hit.pdfName,
            result.hit.page
          )}
        >
          <Row>
            <Col>
              <ResultText
                result={result}
                displayPageOnly={this.props.index != 0}
              />
            </Col>
          </Row>
        </a>
        {dataArr.length > 1 ? (
          <Row>
            <Col>
              <div className={appClasses.leftDiv}>
                <Button
                  color="link"
                  onClick={this.toggle}
                  className={appClasses.moreResults}
                >
                  בעמוד זה קיימות {dataArr.length - 1} תוצאות נוספות
                  <Media
                    src={dropdownDown}
                    alt="עוד תוצאות"
                    className={appClasses.moreResultsImg}
                  />
                </Button>
              </div>
            </Col>{" "}
          </Row>
        ) : (
          ""
        )}
        <Row></Row>
        <MoreResults
          isOpen={this.state.collapse}
          closeHeandler={() => this.toggle()}
          list={dataArr}
          result={result}
        ></MoreResults>
      </div>
    );
  }
}

export default PageResults;
